import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from '@reduxjs/toolkit/query/react'

const baseUrl = `${baseURL}/feedbacks/`

export const feedbackApiService = createApi({
    reducerPath: 'feedbackApi',
    baseQuery: fetchBaseQuery({ baseUrl }),

    endpoints: (builder) => ({
        createFeedback: builder.mutation({
            query: (body) => ({
                url: '',
                method: "POST",
                body
            })
        })
    })
})

export const {
    useCreateFeedbackMutation
} = feedbackApiService
